import * as React from 'react';
import { SVGProps } from 'react';

const FileIconRarSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      d="M11 11V8.01h-1V7h1v.5c.22-.18.687-.5 1-.5h2v1h-1.35c-.213 0-.373.07-.48.21a.708.708 0 0 0-.17.41V11h1v1h-3v-1h1ZM18.95 12a.66.66 0 0 1-.29-.08.818.818 0 0 1-.26-.22.73.73 0 0 1-.61.3h-1.34c-.507 0-.877-.1-1.11-.3-.227-.207-.34-.557-.34-1.05v-.1C15 9.517 15.487 9 16.46 9H18v-.35c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17H15.5V7h1.8c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22V11c0 .1.037.177.11.23.08.047.21.07.39.07v.7h-.55Zm-1.41-1c.2 0 .327-.047.38-.14a.72.72 0 0 0 .08-.36V10h-1.4a.583.583 0 0 0-.6.6v-.1c0 .173.04.3.12.38.08.08.207.12.38.12h1.04ZM21 11V8.01h-1V7h1v.5c.22-.18.687-.5 1-.5h2v1h-1.35c-.213 0-.373.07-.48.21a.708.708 0 0 0-.17.41V11h1v1h-3v-1h1Z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17H9v16h16V17h-7v1h6v14H10V17Zm2 0h3v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h1v4h-3v-4h1v-2h-2v-1h2v-1h-2v-1h2v-1h-2v-1h2v-1h-2v-1Zm3 10h-1v2h1v-2Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconRarSizeM;
